import React from 'react';
import { BaseTypography } from '../../BaseTypography/BaseTypography';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';

type TPasswordHint = {
  password: string;
};

const useStyles = makeStyles(() => ({
  passwordHints__title: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '18px',
    color: '#333333',
    marginBottom: '10px',
  },
  passwordHints__list: {
    display: 'grid',
    gridGap: '5px',
  },
  passwordHint: {
    display: 'grid',
    gridTemplateColumns: '12px minmax(200px, 222px)',
    gridGap: '9px',
    alignItems: 'center',
  },
}));

export const PasswordHint: React.FC<TPasswordHint> = (props) => {
  const { password } = props;
  const classes = useStyles();

  const hints = [
    { title: 'At least 8 characters', ok: password.length >= 8 },
    { title: 'At least 1 number', ok: /\d+/.test(password) },
    {
      title: 'One upper case, one lower case character',
      ok: /^(?=.*[a-z])(?=.*[A-Z])/.test(password),
    },
  ];
  return (
    <div>
      <BaseTypography className={classes.passwordHints__title}>
        For the best protection your password must include:
      </BaseTypography>

      <div className={classes.passwordHints__list}>
        {hints.map((hint) => {
          return (
            <div className={classes.passwordHint} key={hint.title}>
              {hint.ok ? (
                <DoneIcon style={{ fontSize: '14px' }} color="primary" />
              ) : (
                <CloseIcon style={{ fontSize: '14px' }} color="secondary" />
              )}
              <BaseTypography variant="smallText">{hint.title}</BaseTypography>
            </div>
          );
        })}
      </div>

      <BaseTypography
        className={classes.passwordHints__title}
        style={{ marginTop: '10px', fontWeight: 500 }}
      >
        Don’t use your name, email or phone.
      </BaseTypography>
    </div>
  );
};
